// Libs / Helpers
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import InformationBubble from 'Components/information-bubble/InformationBubble';
import Label from 'Components/forms/label/Label';
import { COLORS } from "Constants/BIDashboardConstants.js"

// Style
import './TableCheckbox.scss';

const TableCheckbox = ({ checkBoxKey, onChange, id, isChecked, label, readonly, extraClass, optionalTooltip, optionalTooltipTitle, disabled, extraInputStyle, extraLabelStyle, isSvg, isNotification, isOpacityChange, checkBoxWidth, checkBoxHeight }) => {
  const wrapperClass = classnames('checkbox-field', {
    [extraClass]: extraClass,
  });
  const labelClass = classnames('checkbox-label', {
    checked: !isSvg ? isChecked : false,
    readonly,
  });
  const tooltip = optionalTooltip && <InformationBubble id={id} info tooltipContent={optionalTooltip} tooltipTitle={optionalTooltipTitle} />;
  const checkBoxStyle = !isChecked ? {
    cursor: 'pointer',
    border: `1px solid ${COLORS.oneGp.smoke}`,
    background: !isNotification || !disabled ? 'white' : '#AAC2D3',
    height: 20,
    width: 20,
  } : { cursor: 'pointer', height: 20, width: 20 };
  return (

    <div className={wrapperClass} style={{ display: 'inline-flex', paddingLeft: 0 }}>
      {!isSvg && <input
        type="checkbox"
        className="checkbox"
        onChange={() => onChange(checkBoxKey)}
        id={id}
        checked={isChecked}
        disabled={disabled || readonly}
        style={extraInputStyle}
      />}


      {isSvg && !disabled &&
        <span style={checkBoxStyle} onClick={() => onChange(checkBoxKey)}>
          {!isChecked && <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path /></svg>}
          {isChecked && <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" color={!isNotification ? COLORS.oneGp.globalBlue : "#1362E2"} opacity={isNotification && isOpacityChange ? "40%" : "100%"} viewBox="0 0 24 24"><path d="M0 0v24h24v-24h-24zm11 17l-5-5.299 1.399-1.43 3.574 3.736 6.572-7.007 1.455 1.403-8 8.597z" /></svg>}

        </span>
      }
      <text></text>

      {isSvg && disabled &&
        <span style={checkBoxStyle}>
          {!isChecked && <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path /></svg>}
          {isChecked && <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" color={!isNotification ? "rgba(0, 0, 0, 0.65)" : "#AAC2D3"} viewBox="0 0 24 24"><path d="M0 0v24h24v-24h-24zm11 17l-5-5.299 1.399-1.43 3.574 3.736 6.572-7.007 1.455 1.403-8 8.597z" /></svg>}

        </span>}

      <Label
        htmlFor={id}
        labelClass={labelClass}
        extraStyle={extraLabelStyle}
      >
        {label}
      </Label>

    </div>
  );
};

TableCheckbox.propTypes = {
  onChange: PropTypes.func.isRequired,
  id: PropTypes.string,
  isChecked: PropTypes.bool,
  readonly: PropTypes.bool,
  label: PropTypes.string,
  extraClass: PropTypes.string,
  optionalTooltip: PropTypes.string,
  optionalTooltipTitle: PropTypes.string,
  disabled: PropTypes.bool,
};

TableCheckbox.defaultProps = {
  id: null,
  label: '',
  disabled: false,
  readonly: false,
  extraClass: '',
  isChecked: false,
  optionalTooltip: null,
  optionalTooltipTitle: null,
  extraInputStyle: {},
  extraLabelStyle: {},
  isSvg: true,
  isNotification: false,
  isOpacityChange: false,
  checkBoxKey: 0,
};

export default TableCheckbox;
